var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('div',{staticClass:"slogan-div"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"secondary-color mt-3 mb-3"},[_vm._v(_vm._s(_vm.$t("slogan.title").toUpperCase()))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }